import React, { useState } from 'react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);




const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError(null);
  setMessage(null);

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/staff/forgot-password`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      const backendError = data.message || 'Failed to send reset link.';
      throw new Error(backendError);
    }

    if (data.success) {
      setMessage('Password reset link sent! Please check your email.');
    } else {
      setError(data.message || 'Error sending reset link. Please try again.');
    }
  } catch (err) {
    if (
      err.message === 'Failed to fetch' ||
      err.message.includes('NetworkError') ||
      err.message.includes('Network request failed')
    ) {
      setError('Internet connection error. Please check your network.');
    } else {
      setError(err.message || 'Something went wrong. Please try again.');
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div className='max-w-xl mx-auto mt-8 p-4 bg-white shadow-md rounded'>
      <h2 className='text-2xl font-bold mb-4 text-center'>Forgot Password</h2>
      <p className='mb-4 text-center text-gray-500'><b className='italic text-gray-600'>for Staff Only,</b> This will send a password reset link to your email.</p>
      <form onSubmit={handleSubmit} className='space-y-4'>
        <div>
          <label className='block mb-2'>Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className='w-full p-2 border rounded'
            placeholder='example@mail.com'
          />
        </div>
        {error && <p className='text-red-600'>{error}</p>}
        {message && <p className='text-green-600'>{message}</p>}
        <button type="submit" disabled={loading} className='w-full bg-green-600 text-white py-2 px-4 rounded'>
          {loading ? 'Sending link...' : 'Send Reset Link'}
        </button>
      </form>
    </div>
  );
};


export default ForgotPassword;
